import { render, staticRenderFns } from "./question.vue?vue&type=template&id=e0f36a16&scoped=true&"
import script from "./question.vue?vue&type=script&lang=js&"
export * from "./question.vue?vue&type=script&lang=js&"
import style1 from "./question.vue?vue&type=style&index=1&id=e0f36a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f36a16",
  null
  
)

export default component.exports